import { Field } from "formik";
import React, { Fragment, useEffect, useRef, useState } from "react";
import EyeCloseIcon from "../../assets/icons/eye-close-icon";
import EyeOpenIcon from "../../assets/icons/eye-open-icon";
import StarIcon from "../../assets/icons/req-star";
import ErrorMsg from "./error-msg";
import "./form.css";

export default function InputPhoneField({
  inputClass = "",
  containerClass = "mb-2 position-relative",
  parentClass = "flex items-center m-0 p-0 w-full",
  labelClass = "whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]",
  defaultInputClass = "min-h-[42px]  rounded-r-[8px]  px-2  bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--input-font-weight)]  input-field-no-spin-buttons placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:border-[var(--input-focus)] focus:text-[var(--input-color)] focus:bg-[var(--input-bg)] ",
  errorBorder = "border border-[var(--input-error-border)]",
  inputBorder = "border border-[var(--input-border)]",
  //   max = "",
  //   min = 0,
  isDisabled = false,
  name = "",
  placeholder = "Enter 10-digit mobile number",
  label = "Mobile Number",
  id,
  type = "number",
  errMsgContainerClass = "",
  isContainer = true,
  isUnit = false,
  unitType = localStorage?.getItem("currency") ?? "₹",
  unitPosition = "left",
  isPasswordEye = false,
  passwordEyeStyle = { top: "44%" },
  autoComplete = "",
  unitClassName = "",
  children,
  isRequired = false,
  labelWidth = "10rem",
  prefixicon = "",
  maxValue,
  countryCode = "+91", // New prop for country code
  countryCodeClass = "min-h-[42px] px-3 bg-[var(--phone-country-code-bg-color)] text-[var(--input-color)] border border-[var(--input-border)] rounded-l-[8px] flex items-center text-[length:var(--input-font-size)] font-[var(--input-font-weight)]", // Updated styling for country code - removed border-r-0
  handleChange = (e, field) => {
    field.onChange(e);
  },
  autoFocus = false,
  maxLength = 10,
  onKeyDown = (event) => {
    const validKey = /^[0-9]+$/;
    if (
      !validKey.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      event.key !== "Tab" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowRight"
    ) {
      event.preventDefault();
    }
  },
  onBlur,
  unitContainerClass = "flex unit_input__container",
  unitContainerErrorClass = "flex unit_input_container__error",
  passwordEyeClass = "position-absolute  end-0 translate-middle  cursor_pointer",
  inputRef,
}) {
  const finalInputClass = inputClass
    ? `${defaultInputClass} ${inputClass}`
    : defaultInputClass;
  const Container = isContainer ? "div" : Fragment;
  const UnitContainer = isUnit ? "div" : Fragment;
  const PasswordEyeContainer = isPasswordEye ? "div" : Fragment;
  const [passInputType, setPassInputType] = useState("password");

  useEffect(() => {
    if (autoFocus) {
      if (inputRef?.current) {
        inputRef?.current?.focus();
      }
    }
  }, []);

  return (
    <Container
      {...(isContainer && containerClass ? { className: containerClass } : {})}
    >
      <Field className="no-arrows" name={name}>
        {({ field, meta, form }) => (
          <div className={parentClass}>
            {label && (
              <label
                style={{
                  minWidth: labelWidth,
                }}
                {...(id ? { htmlFor: id } : {})}
                className={`${labelClass} flex  flex-nowrap`}
              >
                <span className="flex items-center gap-2">
                  {prefixicon}
                  {label}
                </span>
                {isRequired && (
                  <span className="ml-2">
                    <StarIcon />
                  </span>
                )}
              </label>
            )}

            <UnitContainer
              {...(unitContainerClass && isUnit
                ? {
                    className: `  ${
                      meta.touched && meta.error
                        ? unitContainerErrorClass
                        : unitContainerClass
                    } ${
                      unitPosition === "right" ? "flex-row-reverse" : ""
                    } w-full`,
                  }
                : {})}
            >
              {isUnit && (
                <div
                  className={`d-flex justify-content-center align-items-center font_poppins mt-1 ${
                    unitPosition === "right" ? "flex-row-reverse" : ""
                  }`}
                >
                  <span
                    className={` fw_500 text-sm align-middle primary_color ${unitClassName} ${
                      unitPosition === "right" ? "ms-1" : "me-1"
                    }`}
                  >
                    {unitType}
                  </span>{" "}
                  {unitPosition !== "image" && (
                    <span className={`input-vr mx-2`}></span>
                  )}
                </div>
              )}

              {/* <PasswordEyeContainer
                {...(isPasswordEye
                  ? {
                      className: `position-relative `,
                    }
                  : {})}
              > */}
              {/* Country Code + Phone Input Container */}
              <div className={`flex w-full`}>
                {/* Country Code Section */}
                <div
                  className={`${countryCodeClass} border-r-0 ${
                    meta.touched && meta.error
                      ? "border-[var(--input-error-border)]"
                      : ""
                  } ${
                    isDisabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : ""
                  }`}
                >
                  {countryCode}
                </div>

                {/* Phone Number Input */}
                <input
                  onWheel={(e) => e.target.blur()}
                  ref={inputRef}
                  {...(isDisabled ? { disabled: true } : {})}
                  {...(autoComplete ? { autoComplete: autoComplete } : {})}
                  type={type}
                  {...field}
                  placeholder={placeholder}
                  {...(id ? { id: id } : {})}
                  className={`${
                    isUnit
                      ? `${finalInputClass} focus_outline__none w-100`
                      : `${
                          meta.touched && meta.error
                            ? errorBorder.replace("border", "border")
                            : inputBorder.replace("border", "border")
                        } ${
                          autoFocus ? "focus:border-focus-color" : "no-arrows"
                        } ${finalInputClass.replace(
                          "rounded-[8px]",
                          "rounded-r-[8px] rounded-l-0"
                        )}  input-field-no-spin-buttons w-full`
                  } ${
                    isDisabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : ""
                  }`}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      type === "number" &&
                      typeof maxValue === "number" &&
                      maxValue > 0
                    ) {
                      const numericValue = parseFloat(value);
                      if (!isNaN(numericValue) && numericValue > maxValue) {
                        const syntheticEvent = {
                          ...e,
                          target: {
                            ...e.target,
                            value: maxValue.toString(),
                          },
                        };
                        handleChange(syntheticEvent, field);
                        field.onChange(syntheticEvent);
                        return;
                      }
                    }

                    if (value.length <= maxLength) {
                      handleChange(e, field);
                      field.onChange(e);
                    }
                  }}
                  onBlur={onBlur}
                  onKeyDown={onKeyDown}
                />
              </div>
              {/* 
                {isPasswordEye &&
                  (passInputType === "password" ? (
                    <button
                      style={passwordEyeStyle}
                      type="button"
                      className={`${passwordEyeClass} `}
                    >
                      <EyeCloseIcon onClick={() => setPassInputType("text")} />
                    </button>
                  ) : (
                    <button
                      type="button"
                      style={passwordEyeStyle}
                      className={`${passwordEyeClass} border-0`}
                    >
                      {" "}
                      <EyeOpenIcon
                        onClick={() => setPassInputType("password")}
                      />
                    </button>
                  ))} */}
              {/* </PasswordEyeContainer> */}
            </UnitContainer>
          </div>
        )}
      </Field>
      <ErrorMsg containerClass={errMsgContainerClass} name={name} />
      {children}
    </Container>
  );
}
